import React, { useState } from "react";
import Modal from 'react-bootstrap/Modal';
import { Button } from 'react-bootstrap';


interface ConfirmationModalProps {
    modalState: ConfirmationModalState
}

const ConfirmationModal: React.FC<ConfirmationModalProps> = (props: ConfirmationModalProps) => {

    if (!props.modalState.isShowing) return <></>;

    return <Modal show onHide={props.modalState.onCancel} backdrop="static">
        <Modal.Header closeButton>
            <Modal.Title>
                {props.modalState.title}
            </Modal.Title>
        </Modal.Header>
        <Modal.Body>
            {props.modalState.text}
        </Modal.Body>
        <Modal.Footer>
            <div className="pull-right mt-3">
                {props.modalState.isAlert &&
                    <Button variant="primary" className="ml-2" onClick={props.modalState.onCancel}>
                        OK
                    </Button>
                }
                {!props.modalState.isAlert && <>
                    <Button variant="secondary" className="ml-2" onClick={props.modalState.onCancel}>
                        Cancel
                    </Button>&nbsp;
                    <Button variant="primary" onClick={props.modalState.onConfirm}>
                        Confirm
                    </Button></>
                }
            </div>
        </Modal.Footer>
    </Modal>
}

export default ConfirmationModal;

export interface ConfirmationModalState {
    isShowing: boolean;
    title?: string;
    text?: string;
    onConfirm?: (() => void);
    onCancel?: (() => void);
    isAlert?: boolean;
}

export interface ConfirmationModalController {
    show(title: React.ReactNode, text: React.ReactNode, successHandler: (() => void), cancelHandler?: (() => void), isAlert?: boolean): void;
    state: ConfirmationModalState;
}

export function useConfirmationModal(): ConfirmationModalController {

    const [confirmationModalState, setConfirmationModalState] = useState<ConfirmationModalState>({ isShowing: false, isAlert: false, title: "", text: "", onConfirm: null, onCancel: null });

    function onCancel() {
        setConfirmationModalState({ ...confirmationModalState, isShowing: false });
        if (confirmationModalState.onCancel) confirmationModalState.onCancel();
    }

    function onConfirm() {
        confirmationModalState.onConfirm();
        setConfirmationModalState({ ...confirmationModalState, isShowing: false });
    }

    function show(title: string, text: string, successHandler: (() => void), cancelHandler?: (() => void), isAlert: boolean = false) {
        setConfirmationModalState({ ...confirmationModalState, isShowing: true, isAlert, title, text, onConfirm: successHandler, onCancel: cancelHandler });
    }

    return {
        state: {
            isShowing: confirmationModalState.isShowing,
            title: confirmationModalState.title,
            text: confirmationModalState.text,
            onConfirm,
            onCancel,
            isAlert: confirmationModalState.isAlert
        },
        show

    }

}